var base = require('settings/profile/update-contact-information');

Vue.component('spark-update-contact-information', {
    mixins: [base],

    // Die zusätzlichen Felder name_first und name_last werden hier gesetzt

    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                name_fist: '',
                name_last: '',
                department: '',
            }), Spark.forms.updateContactInformation)
        };
    },


    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.name_first = this.user.name_first
        this.form.name_last = this.user.name_last
        this.form.department = this.user.department
    },
});
